package com.tovtalk.data.local

import app.cash.sqldelight.Query
import app.cash.sqldelight.Transacter
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlPreparedStatement

/**
 * JS Database Driver Factory – stub that throws on use.
 * Replace with WebWorkerDriver when generateAsync is enabled and LocalDataSource is migrated to suspend.
 *
 * TODO(db): When a real JS/WebWorker driver is implemented, also enable foreign keys
 * (PRAGMA foreign_keys=ON) per connection to match Android/iOS, so ON DELETE CASCADE fires.
 * No-op here: this stub throws on any use, so we intentionally leave behavior unchanged.
 */
actual class DatabaseDriverFactory {
    actual fun createDriver(): SqlDriver = StubSqlDriver
}

private object StubSqlDriver : SqlDriver {
    override fun close() {}
    override fun execute(
        identifier: Int?,
        sql: String,
        parameters: Int,
        binders: (SqlPreparedStatement.() -> Unit)?
    ): QueryResult<Long> = throw UnsupportedOperationException("SQLDelight DB not implemented for JS in this build")

    override fun <R> executeQuery(
        identifier: Int?,
        sql: String,
        mapper: (SqlCursor) -> QueryResult<R>,
        parameters: Int,
        binders: (SqlPreparedStatement.() -> Unit)?
    ): QueryResult<R> = throw UnsupportedOperationException("SQLDelight DB not implemented for JS in this build")

    override fun newTransaction(): QueryResult<Transacter.Transaction> =
        throw UnsupportedOperationException("SQLDelight DB not implemented for JS in this build")

    override fun currentTransaction(): Transacter.Transaction? = null

    override fun addListener(vararg queryKeys: String, listener: Query.Listener) {}

    override fun removeListener(vararg queryKeys: String, listener: Query.Listener) {}

    override fun notifyListeners(vararg queryKeys: String) {}
}
